module.exports = __webpack_public_path__ + "static/media/grpc.0ca145143fcc8b0e5025ab2f8e9b0d4a.svg";